import React from "react";
import styled from "styled-components";

const BizButton = ({
  label,
  isRounded,
  color,
  width = "100%",
  onClick,
  isOutlined,
  size = "md",
  prefixIcon,
  postfixIcon,
  fontColor,
  disabled = false,
}) => {
  return (
    <StyledBizButton
      fontColor={fontColor}
      size={size}
      color={color}
      isRounded={isRounded}
      isOutlined={isOutlined}
      width={width}
      onClick={onClick}
      disabled={disabled}
    >
      {prefixIcon && prefixIcon}
      {label}
      {postfixIcon && postfixIcon}
    </StyledBizButton>
  );
};

const StyledBizButton = styled.button`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${(props) => `2px solid ${props.color}`};
  border-radius: ${(props) => (props.isRounded ? "32px" : "8px")};
  background: ${(props) => (props.isOutlined ? "transparent" : props.color)};
  width: ${(props) => props.width};
  color: ${(props) =>
    props.isOutlined
      ? props.color
      : props.fontColor
        ? props.fontColor
        : "white"};
  padding: ${(props) => (props.size === "sm" ? "12px 14px" : " 14px 16px")};
  font-size: ${(props) => (props.size === "sm" ? "0.9rem" : "1rem")};
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export default BizButton;
